// Perplexity-owned hosts whose URLs we are willing to re-anchor on the user's
// current host. External providers (accounts.google.com, slack.com, etc.) and
// any unknown host pass through untouched.
const PERPLEXITY_REDIRECT_HOSTS = new Set([
    'perplexity.ai',
    'www.perplexity.ai',
    'enterprise.perplexity.ai',
    'staging.perplexity.ai',
    'testing.perplexity.ai',
]);
// Rewrite the host of an absolute Perplexity URL to the user's current host so
// a popup opened from `enterprise.perplexity.ai` does not navigate to
// `www.perplexity.ai` (where host-only session cookies would be stripped and,
// for enterprise users, the host is intentionally blocked at the network
// layer). The backend's host plumbing for connector OAuth redirects relies on
// X-Forwarded-Host propagating through a long chain; this is a single
// defensive checkpoint at the places every connector popup goes through.
//
// No-op when:
//   - the URL is relative (window.open already resolves it against the origin)
//   - the URL host is not a known Perplexity host (external OAuth provider)
//   - the URL host already matches window.location.host (e.g. www users)
//   - the user's current host is not a known Perplexity host (avoid rewriting
//     to something unexpected during local dev / preview environments)
export function rewritePerplexityHost(url) {
    if (typeof window === 'undefined')
        return url;
    let parsed;
    try {
        parsed = new URL(url);
    }
    catch {
        return url;
    }
    if (!PERPLEXITY_REDIRECT_HOSTS.has(parsed.host))
        return url;
    if (!PERPLEXITY_REDIRECT_HOSTS.has(window.location.host))
        return url;
    if (parsed.host === window.location.host)
        return url;
    parsed.host = window.location.host;
    return parsed.toString();
}
//# sourceMappingURL=rewritePerplexityHost.js.map